var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepperActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67695 20.567C2.53095 18.021 0.757949 12.758 2.71695 8.144C4.87495 3.06 10.7449 0.688001 15.8289 2.846C20.9129 5.004 23.2849 10.875 21.1269 15.959C20.3189 17.8704 18.9337 19.4816 17.1649 20.567",
    stroke: "#43B4E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16V20.4C17 20.5591 17.0632 20.7117 17.1757 20.8243C17.2883 20.9368 17.4409 21 17.6 21H22M12 22.01L12.01 21.999",
    stroke: "#43B4E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperActive);
export default __webpack_public_path__ + "static/media/stepper-active.92825da162bdd1763c3426eb97dc7162.svg";
export { ForwardRef as ReactComponent };